import { render, staticRenderFns } from "./NgRolesByUser.vue?vue&type=template&id=2551e91f"
import script from "./NgRolesByUser.vue?vue&type=script&lang=js"
export * from "./NgRolesByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports